const menu = () => {
	const body = document.querySelector('html');
	const burger = document.querySelector('.menu__burger');
	const close = document.querySelector('.menu__close');
	const section = document.querySelector('.menu__section');
	const link = document.querySelectorAll('.menu__item');
	const back = document.querySelector('.header__back');
	const home = document.querySelector('.menu__item[data-name="home"]');

	const toggleMenu = () => {
		if (!section.classList.contains('active')) {
			body.classList.add('is-lock-scroll');
			section.classList.add('active');
		} else {
			body.classList.remove('is-lock-scroll');
			section.classList.remove('active');
		}
	};
	burger.addEventListener('click', toggleMenu);
	close.addEventListener('click', toggleMenu);
	back.addEventListener('click', () => {
		link.forEach((element) => {
			element.classList.remove('active');
		});
		home.classList.add('active');
	});

	link.forEach((element) => {
		element.addEventListener('click', (event) => {
			const target = event.currentTarget;
			link.forEach((el) => {
				el.classList.remove('active');
			});
			target.classList.add('active');
			toggleMenu(event);
		});
	});
};
const changeActiveLink = (pathname) => {
	const link = document.querySelector(`.menu__item[href="${pathname}"]`);
	const linkMain = document.querySelector('.menu__item[href="/"]');

	if (link) {
		link.classList.add('active');
	} else {
		linkMain.classList.add('active');
	}
};
export {menu, changeActiveLink};
